export interface FeedSimplePostDto {
	audience: number;
	title: string;
	textContnet: string | null;
	linkContent: string | null;
	binaryContentBase64: string | null;
	binaryContentType: string | null;
}
export interface FeedContentDto {
	modifiedDate: Date;
	id: number;
	textContnet: string | null;
	linkContent: string | null;
	binaryContentBase64: string | null;
	binaryContentBase64Save: any | null;
	binaryContentType: string | null;
	modified: number | null;
}

export interface FeedDto {
	modifiedDate: Date;
	id: number;
	title: string;
	authorUserId: number;
	authorPersonId: number;
	authorName: string;
	locationName: string;
	isSeen: boolean;
	reaction: number;
	actionCode: number;
	actionInfo: string | null;
	modified: number;
	content: FeedContentDto[];
}
export interface ParticipantDto {
	id: number;
	name: string;
	avatarBase64: string | null;
}

export interface FeedResponseDto {
	feeds: FeedDto[];
	participants: ParticipantDto[];
}